import { onlyNumbers } from '@cloudapps/string-helper';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { Grid, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';

import { applicationSetField } from '../../../redux/scholarship.actions';
import { EnumSections, MAppFinancial } from '../../../redux/scholarship.models';
import { ApplicationFormContainer } from '../../ApplicationsForm/applications-form.styles';

interface IApplicationsFormFinancialProps {
  id: string;
  thisSection: Partial<MAppFinancial>;
  dispatchApplicationUpdate: (id: string, section: EnumSections, field: string, value: unknown) => void;
}

const ApplicationsFormFinancial = ({ id, thisSection, dispatchApplicationUpdate }: IApplicationsFormFinancialProps) => {
  const { trackPageView } = useMatomo();

  // Track page view
  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <ApplicationFormContainer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Fragment>
            <Typography variant="h6" gutterBottom>
              Income Information
            </Typography>
            <Typography variant="body2" gutterBottom>
              When filling out this section, be sure to indicate the adjusted gross income and number of dependents actually shown on the
              federal income tax return you filed for last year since application scores are based, in part, on these numbers. If your child
              is approved for a scholarship or grant, you will be asked to submit a copy of this tax return for verification purposes.
            </Typography>
          </Fragment>
        </Grid>
        <Grid item xs={12} sm={4}>
          <CurrencyTextField
            required
            label="Adjusted Gross Income"
            value={thisSection.income || ''}
            outPutFormat="string"
            decimalPlaces={0}
            maximumValue="120000"
            onChange={(event) => dispatchApplicationUpdate(id, EnumSections.FINANCIAL, 'income', onlyNumbers(event.target.value))}
          />
          <Typography variant="caption" display="block" style={{ color: 'grey' }} gutterBottom>
            must be $120,000 or less
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          Indicate the adjusted gross income shown on the federal income tax return you filed for last year (Line 11 on Form 1040). If you
          were married but filed separately, indicate the combined adjusted gross income from the income tax returns for both you and your
          spouse.
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            key={`dependents${id}`}
            required
            id="dependents"
            name="dependents"
            label="Dependents"
            value={thisSection.dependents || ''}
            inputProps={{ maxLength: 2 }}
            onChange={(event) => dispatchApplicationUpdate(id, EnumSections.FINANCIAL, 'dependents', onlyNumbers(event.target.value))}
          />
          <Typography variant="caption" display="block" style={{ color: 'grey' }} gutterBottom>
            do not include yourself or your spouse
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          Indicate the number of dependents shown on the federal income tax return you filed for last year.
        </Grid>
      </Grid>
    </ApplicationFormContainer>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchApplicationUpdate: (id: string, section: EnumSections, field: string, value: unknown): void => {
    dispatch(applicationSetField(id, section, field, value));
  }
});
export default connect(null, mapDispatchToProps)(ApplicationsFormFinancial);
